<template>
  <div>
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <q-form v-else @submit="this.onSubmit" class="form">
      <div class="form__item">
        <div>{{ data.body.resident_name }}</div>
        <div style="margin-top: 15px;">
          <CustomSelect :options="this.entrancesOptions" :label="'Выберите Подъезд'"
            optionValueKey="project_entrance_id" optionLabelKey="entrance_num"
            :value="this.formData.project_entrance_id || ''"
            @change="(value, row) => onChange('project_entrance_id', value, row)" :required="true" :clearable="false" />
        </div>
      </div>

      <div class="form__item">
        <CustomSelect :options="this.residentsOptions"
          :label="`Проект для ${data?.isTransfer ? 'разделения проекта' : 'дублирования подъезда'} `"
          optionValueKey="project_id" optionLabelKey="labelWithId" :value="this.formData.project_id || ''"
          @change="(value) => onChange('project_id', value)" :required="true" :clearable="false" />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { getProjectsById } from "@/views/ProjectsEntry/services";

export default {
  name: "copy-paste-entrance-properties",
  components: { CustomInput, CustomSelect, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: false,
      isFetching: false,
      residentsOptions: [],
      entrancesOptions: [],
      formData: {
        project_id: ''
      },
    };
  },
  async mounted() {
    this.isFetching = true;
    await this.getProjectsOptions(this.data?.body?.project_id);
    this.availableEntrances();
    this.isFetching = false;
  },
  methods: {
    availableEntrances() {
      this.data?.body?.entrances_info?.forEach(entrance => {
        this.entrancesOptions.push({
          project_entrance_id: entrance.project_entrance_id,
          entrance_name: entrance.entrance_name,
          entrance_num: entrance.entrance_num
        })
      })
    },
    async getProjectsOptions(project_id) {
      const res = await getProjectsById(project_id);
      this.residentsOptions = (res || []).map(item => ({
        ...item,
        labelWithId: `${item.resident_name} (ID - ${item.project_id})`
      }));
    },
    async onChange(key, value) {
      this.formData[key] = value;
      return;
    },
    async onSubmit() {
      this.loading = true;
      try {
        await this.data?.onSubmit(this.formData);
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  gap: 10px;

  @media (max-width: 428px) {
    min-width: 100%;
  }
}

.form__item_date {
  display: flex;
  flex-direction: column;

}

.form__item_date span {
  font-size: 12px;
  padding-left: 1px;
  color: gray;
}
</style>
